module.exports = __webpack_public_path__ + "img/check-grey.c5fde03c.svg";